import React from 'react'
import { BonusCampaignsDto } from '@/api/Wallet/Types/MarketingBonusCampaignDto'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabNavigate } from '@/hooks/useTabNavigate'

import { CampaignTab } from '../CampaignSlug'
import { BonusCampaignTab } from './BonusCampaignSlug'

interface Props {
  data: BonusCampaignsDto
  tab: CampaignTab
}

export const BonusCampaignNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  return (
    <div>
      <NavigationHeader />
      <Tabs value={props.tab} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={BonusCampaignTab.DETAILS}>Details</TabsTrigger>

          {props.data && (
            <TabsTrigger value={BonusCampaignTab.PARTICIPATING_COUNTRIES}>
              Participating Countries
            </TabsTrigger>
          )}
        </TabsList>
      </Tabs>
    </div>
  )
}
